// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["commons"], () => (__webpack_require__("./app/js/index.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
